import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./Home";
import AdminDashboard from "./components/admin/AdminDashboard";
import Login from "./components/admin/Login";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import { useAttribution } from "./components/AttributionProvider";
import TrafficTracker from "./components/utils/TrafficTracker";
import CampaignCaptureForm from "./components/CampaignCaptureForm";
import LeadPathPortal from "./components/LeadPathPortal";
import "./index.css";

function AppRoutes() {
  useAttribution();
  return (
    <>
      <TrafficTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apply" element={new URLSearchParams(window.location.search).has("lp_campaign")
          ? <CampaignCaptureForm brand="Legacy Ease" eyebrow="Final Expense request" heading="Protect the people who matter with a clear first step." intro="Share your contact information now, then choose whether to continue with a short optional final-expense discovery." tracker={(name,details)=>window.legacyEvents?.track?.(name,details)} />
          : <Home startFunnel />} />
        <Route path="/client-portal" element={<LeadPathPortal />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return <BrowserRouter><AppRoutes /></BrowserRouter>;
}
